<h3 class="quick-start-guide-title" translate="quick-start-guide_title" [translateParams]="translationParams"></h3>
<p [translate]="'quick-start-guide_title_message_one'" [translateParams]="translationParams"></p>
<div class="yellowcard">
	<i class="ficon-lightbulb-o"></i>
	<span [innerHTML]="'quick-start-guide_title_message_two' | translate : quickStartTranslationParams"></span>
</div>
<p [innerHTML]="'quick-start-guide_title_message_three' | translate"></p>
